import { Authority } from '@/shared/security/authority';

const Restaurant = () => import('@/pages/restaurant/restaurant.vue');
const RefreshPage = () => import('@/pages/restaurant/stripe/refresh-page.vue');
const ReturnPage = () => import('@/pages/restaurant/stripe/return-page.vue');

export default [
  {
    path: '/restaurant',
    name: 'Restaurant',
    component: Restaurant,
    meta: {
      layout: 'profile-layout',
      authorities: [Authority.RESTAURANT],
    },
  },
  {
    path: '/stripe/account/refresh',
    name: 'RefreshPage',
    component: RefreshPage,
    meta: {
      layout: 'info-layout',
      authorities: [Authority.RESTAURANT],
    },
  },
  {
    path: '/stripe/account/return',
    name: 'ReturnPage',
    component: ReturnPage,
    meta: {
      layout: 'info-layout',
      authorities: [Authority.RESTAURANT],
    },
  },
];
